import React from "react";

const Button = ({
  btnOutline = false,
  title,
  icon,
  bgColor = "bg-primary",
  hoverBg = "hover:bg-primary",
  ringColor = "ring-primary",
  borderColor = "border-primary",
  className = "inline-flex",
}) => {
  let btnClass = `${bgColor} text-white hover:bg-cyan-300`;

  if (btnOutline) {
    btnClass = `border ${borderColor} text-primary hover:text-white ${hoverBg}`;
  }

  return (
    <a
      href="/"
      className={`${btnClass} ${className} items-center gap-2 text-sm rounded-md px-5 py-2 ring-1 ${ringColor} hover:ring-cyan-300 transition duration-100`}
    >
      {icon}
      {title}
    </a>
  );
};

export default Button;
